import { Action, createReducer, on } from '@ngrx/store';
import {
    loadCandidateProfileComponents,
    loadCandidateProfileComponentsFailure,
    loadCandidateProfileComponentsSuccess,
    loadShouldDisplayCandidateProfileComponents,
    loadShouldDisplayCandidateProfileComponentsFailure,
    loadShouldDisplayCandidateProfileComponentsSuccess,
    showMaxEducationEntriesReachedError,
    verifyContactInfoComponentsFailure,
    verifyRTOComponentFailure
} from './profile-component.actions';
import { ProfileComponentState } from './profile-component.state';

export const initialState: ProfileComponentState = {
    allowProfileComponentsView: false,
    profileComponents: [],
    isLoading: false,
    error: undefined,
    maxEducationEntriesReached: false
};

const reducer = createReducer(
    initialState,
    on(loadCandidateProfileComponents, (state) => ({
        ...state,
        isLoading: true
    })),

    on(loadCandidateProfileComponentsSuccess, (state, action) => ({
        ...state,
        isLoading: false,
        profileComponents: action.profileComponents
    })),

    on(loadCandidateProfileComponentsFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: JSON.stringify(action.error)
    })),

    on(loadShouldDisplayCandidateProfileComponents, (state) => ({
        ...state,
        isLoading: true
    })),

    on(loadShouldDisplayCandidateProfileComponentsSuccess, (state, action) => ({
        ...state,
        isLoading: false,
        allowProfileComponentsView: action.allowProfileComponentsView
    })),

    on(loadShouldDisplayCandidateProfileComponentsFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: JSON.stringify(action.error)
    })),

    on(verifyContactInfoComponentsFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: JSON.stringify(action.error)
    })),

    on(verifyRTOComponentFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: JSON.stringify(action.error)
    })),

    on(
        showMaxEducationEntriesReachedError,
        (state): ProfileComponentState => ({
            ...state,
            maxEducationEntriesReached: true
        })
    )
);

export function candidateProfileComponentsReducer(state: ProfileComponentState | undefined, action: Action) {
    return reducer(state, action);
}
